export default __webpack_public_path__ + "static/media/YOOZ_TOP_UP_REQUIREMENT_POST.d8153518.jpg";